'use strict';

const Backbone = require('backbone');
const WaitTime = require('../models/wait-time').default;

const WaitTimeCollection = Backbone.Collection.extend({

  url: '/online_bookings/ajax_service_wait_times',
  model: WaitTime,

  parse: function (response) {
    return response.data['wait-time'];
  },

});

export default WaitTimeCollection;
